import util from '@/Utils/util';
import * as Fingerprint from '@fingerprint/agent';

export const getVisitorId = async () => {
  const apiKey = util.fingerPrintToken as string;
  const fp = Fingerprint.start({ apiKey });
  const result = await fp.get();
  return result.visitor_id ?? '';
};
